import React, { useState, useEffect } from "react";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { Form, Col } from "react-bootstrap";
import SomeSpinner from "components/Somespinner/Somespinner.js"

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";

import { makeStyles } from "@material-ui/core/styles";

import Button from "components/CustomButtons/Button.js";

import api from "assets/services/api.js";
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";
import { formatDateFilter, formatDateFilterNew } from "services/formatDate.js"
import 'bootstrap/dist/css/bootstrap.min.css';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    colorFont: {
        color: "#434343"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    ftsize: {
        fontSize: "12.6px!important"
    },
    widthSelect: {
        width: "90%",
        marginTop: "10px"
    }
};


const useStyles = makeStyles(styles);

export default function ComissionSellsman() {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }
    const classes = useStyles();
    const { storageId, storageUserType } = useAuth();

    const [loading, setLoading] = useState(false);
    const [br2, setBR2] = useState(false);
    const [controlSnackReady, setControlSnackReady] = useState(false);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [percentOne, setPercentOne] = useState('');
    const [percentTwo, setPercentTwo] = useState('');
    const [zones, setZones] = useState([{ id: 0, name: 'Todos' }]);
    const [zoneID, setZoneID] = useState(0);

    useEffect(() => {
        loadZone();
    }, []);
    useEffect(() => {
        if (controlSnackReady) { showNotificationReady("br") }
    }, [controlSnackReady]);

    const showNotificationReady = place => {
        switch (place) {
            case "br":
                if (!br2) {
                    setBR2(true);
                    setTimeout(function () {
                        setBR2(false);
                        setControlSnackReady(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };
    async function loadZone() {
        const response = await api.get(`/zone/${storageId}?type=${storageUserType}&report=true&search=`);
        if (response.status === 200) {
            if (response.data.zones.length > 0) {
                setZones([...zones, ...response.data.zones]);
            };
        };
    };
    async function download() {
        /*
                await api.get('/sell/admin/download/for/comission/' + id, { responseType: 'blob' }).then(function (response) {
                    let blob = new Blob([response.data], {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/pdf',
                        }
                    });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Comissão de ${sellsman} - ${formatDate(startDate)} à ${formatDate(endDate)}.pdf`;
                    link.click();
                })
                    .catch(function (error) {
                        console.log(error)
                    });
                    */
    };
    async function download2() {

    };
    async function generatePdf() {
        if (startDate > endDate) {
            return alert('Interválo de datas inválido');
        };
        if (percentOne === '' && percentTwo) {
            return alert('Dois parametros de comissao exigido');
        };
        if (percentOne && percentTwo === '') {
            return alert('Dois parametros de comissao exigido');
        };

        if (startDate && endDate) {
            setLoading(true);
            await api.get(
                `/sell/generate/sellsman/for/comission/${storageId}/${zoneID}/${formatDateFilter(startDate)}/${formatDateFilter(endDate)}?comission1=${percentOne}&comission2=${percentTwo}`, {
                responseType: "blob",
            }).then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = `Comissão ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)}.pdf`;
                link.click();
            }).catch(function (error) {
                console.log(error);
            });



            setControlSnackReady(true);
            setLoading(false);
        }
        else {
            return alert('Insira a data para gerar o relatório');
        };

    };
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>today</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorFont}>Clique abaixo para inserir filtro de data primária</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <DatePicker className={classes.marginDate}
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            locale={pt}
                            disabledKeyboardNavigation />
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>event</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorFont}>Clique abaixo para inserir filtro de data primária </h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <DatePicker className={classes.marginDate}
                            selected={endDate}
                            onChange={date => setEndDate(date.withoutTime())}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Digite ou clique aqui"
                            locale={pt}
                            disabledKeyboardNavigation />
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>event</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <div style={{ textAlign: 'center' }}>
                            <h6 className={classes.colorFont}>Defina as comissões </h6>
                            <p className={classes.colorCard}>Caso nao preenchido será considerado padrão p/ operação </p>
                        </div>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridName">
                                <Form.Label>Porcentagem base</Form.Label>
                                <Form.Control
                                    value={percentOne}
                                    className="form-control"
                                    type="double"
                                    onChange={(event) => {
                                        setPercentOne(event.target.value)
                                    }}
                                    autoComplete="off"
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridName">
                                <Form.Label>Porcentagem cheio</Form.Label>
                                <Form.Control
                                    value={percentTwo}
                                    className="form-control"
                                    type="double"
                                    onChange={(event) => {
                                        setPercentTwo(event.target.value)
                                    }}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Form.Row>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} md={12} sm={12}>
                {loading ?
                    <div>
                        <SomeSpinner />
                    </div> :
                    <div></div>
                }
                <Card>
                    <CardHeader className={classes.zindex} color="primary">
                        <h4 className={classes.cardTitleWhite}>Zona</h4>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                        <Form.Row className={classes.widthSelect} >
                            <Form.Group as={Col} controlId="formGridSellsman">
                                <Form.Control onChange={event => setZoneID(event.target.value)} value={zoneID} as="select" defaultValue="Choose...">
                                    {zones.map(zone => (
                                        <option key={String(zone.id)} value={zone.id}>{zone.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Form.Row>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>

                        <Button color="success" onClick={generatePdf}>
                            Gerar comissão
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <Snackbar
                place="br"
                color="success"
                icon={AddAlert}
                message="Comissão gerada com sucesso"
                open={br2}
                closeNotification={() => setBR2(false)}
                close
            />
        </GridContainer>
    );
}